"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Skeleton = void 0;
var _react = _interopRequireDefault(require("react"));
require("./Skeleton.scss");
const Skeleton = () => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
  className: "PriceSummarySkeleton-Row"
}, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
  className: "cds-Skeleton--TextMedium"
}), /*#__PURE__*/_react.default.createElement("div", {
  className: "cds-Skeleton--TextMedium"
})), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
  className: "cds-Skeleton--TextFull"
}), /*#__PURE__*/_react.default.createElement("div", {
  className: "cds-Skeleton--TextFull"
}))), /*#__PURE__*/_react.default.createElement("div", {
  className: "PriceSummarySkeleton-Divider"
}), /*#__PURE__*/_react.default.createElement("div", {
  className: "PriceSummarySkeleton-Row"
}, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
  className: "cds-Skeleton--TextMedium"
})), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
  className: "cds-Skeleton--TextFull"
}))));
exports.Skeleton = Skeleton;
//# sourceMappingURL=Skeleton.js.map